// Import Packages
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Import Pages
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

function CreateContact({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.ACTIVE-DIRECTORY.CREATE-USER.';

    useEffect(() => {
        if (!action.fields.firstName) {
            action.fields.firstName = { value: '', isRequired: true }
        }
        if (!action.fields.lastName) {
            action.fields.lastName = { value: '', isRequired: true }
        }
    }, [action.fields]);

    return (
        <div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'FIRST-NAME')} is_required={true} />
                <TextInput action={action} inputName="firstName" variables={variables} setOpenVariable={setOpenVariable} isRequired={true} hideRequired={true} fieldType={"string"} displayName={t(label + 'FIRST-NAME')} />
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'LAST-NAME')} is_required={true} />
                <TextInput action={action} inputName="lastName" variables={variables} setOpenVariable={setOpenVariable} isRequired={true} hideRequired={true} fieldType={"string"} displayName={t(label + 'LAST-NAME')} />
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'DISPLAY-NAME')} is_required />
                <TextInput action={action} inputName="displayName" variables={variables} setOpenVariable={setOpenVariable} isRequired hideRequired fieldType={"string"} displayName={t(label + 'DISPLAY-NAME')} />
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'DISTINGUISH-NAME')} />
                <TextInput action={action} inputName="distinquishName" variables={variables} setOpenVariable={setOpenVariable} isRequired={false} fieldType={"string"} displayName={t(label + 'DISTINGUISH-NAME')} />
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'EMAIL')} is_required={true} />
                <TextInput action={action} inputName="email" variables={variables} setOpenVariable={setOpenVariable} isRequired={true} hideRequired={true}
                    inputMode="email" fieldType={"string"} displayName={t(label + 'EMAIL')} />
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'DESCRIPTION')} />
                <TextInput action={action} inputName="description" variables={variables} setOpenVariable={setOpenVariable} isRequired={false} fieldType={"string"} displayName={t(label + 'DESCRIPTION')} />
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'DEPARTMENT')} />
                <TextInput action={action} inputName="department" variables={variables} setOpenVariable={setOpenVariable} isRequired={false} fieldType={"string"} displayName={t(label + 'DEPARTMENT')} />
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'TITLE')} />
                <TextInput action={action} inputName="title" variables={variables} setOpenVariable={setOpenVariable} isRequired={false} fieldType={"string"} displayName={t(label + 'TITLE')} />
            </div>
        </div>
    )
}

export default CreateContact;